// This file is generated automatically by `scripts/build/typings.js`. Please, don't change it.

import { nl } from 'date-fns/locale'
export default nl
